/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, delay, put, select, throttle } from 'redux-saga/effects'
import { createSagas } from 'src/helpers/redux'
import { IResponse } from 'src/services/storage/project/http'
import * as settingsService from 'src/services/storage/settings'

import * as app from 'src/store/modules/app'
import * as state from './state'
import { actions, Actions } from './actions'
import { setters } from './index'
import { selectors } from './selectors'

const sagas = createSagas<Actions>(actions, {
  getSettings: function* ({ payload }) {
    const settings: IResponse<settingsService.IGetSettingsData> = yield call(
      settingsService.getSettings,
      payload
    )

    yield put(setters.setSettings(settings.data))
  },
  patchSettings: function* ({ payload }) {
    const settings: IResponse<settingsService.IPatchSettingsData> = yield call(
      settingsService.patchSettings,
      payload
    )
    yield put(
      app.actions.tost.pending({
        type: 'success',
        title: 'Auto-creation settings have been successfully saved',
        description: '',
      })
    )
    yield put(setters.setSettings(settings.data))
  },
})

export default sagas
